import React, { useState } from 'react';
import * as Styles from 'pages/member/wh/WH.style';
import { Grid } from '@mui/material';
import priceCalculator from 'utils/price-calculator';
import UseWh from 'hooks/use-wh';
import Heading from 'components/Heading/Heading';
import { Trans, useTranslation } from 'react-i18next';
import { domainTabs } from 'constants/wh';
import { useSelector } from 'react-redux';
import { UpperCaseWord } from 'assets/css/common-styles';
import { P } from 'components/reusable-css';
import { isSafari } from 'react-device-detect';

const PaymentCard = ({ price, onClick, showTag, paymentType, selected }) => {
  const userAccount = useSelector((state) => state.user.account);
  return (
    <Styles.PaymentCon onClick={onClick} selected={selected}>
      <Styles.RedTag showTag={showTag}>{showTag}</Styles.RedTag>
      <Styles.PriceStep5>
        <Styles.PerMonthStep5>
          <Trans
            i18nKey={paymentType}
            values={{
              price: priceCalculator(price, false),
              currency: userAccount.account_currency,
              currency_symbol: userAccount.account_currency_symbol,
            }}
            components={{ uppercase: <UpperCaseWord />, price: <Styles.PriceUnitStep5 /> }}
          />
        </Styles.PerMonthStep5>
      </Styles.PriceStep5>
    </Styles.PaymentCon>
  );
};

const WHStep5 = ({ formikProp }) => {
  const userAccount = useSelector((state) => state.user.account);
  const { t } = useTranslation();
  const { setFieldValue, values } = formikProp;
  const { withoutDomainPriceYearly, withoutDomainPriceMonthly, yearlyPrice, monthlyPrice } = UseWh({ formikProp });
  const handleSelectPayment = (value) => {
    setFieldValue('options_prepaid', value);
  };
  const [selected, setSelected] = useState(100);
  const handleClick = (index) => setSelected(index);

  const buttons = [
    { id: 1, heading: 'string33', text: 'string19' },
    { id: 0, heading: 'string34', text: 'string18' },
    { id: 2, heading: 'string35', text: 'string20' },
    // { id: 3, heading: 'string36', text: 'string21' },
    { id: 3, heading: 'string37', text: 'string22' },
    { id: 4, heading: 'string38', text: 'string25' },
    { id: 5, heading: 'string39', text: 'string26' },
  ];

  return (
    <Styles.WHStep3SC id="ST5">
      <Heading name={'wh/create.step5_string1'}>
        <Styles.MarginContainer>
          <Grid container>
            <Grid xs={12} sm={12} md={3} lg={3} xl={2}>
              <Styles.HeadingStep5 marginTop>{t('wh/create.step5_string2')}</Styles.HeadingStep5>
            </Grid>
            <Grid container xs={12} sm={12} md={9} lg={9} xl={10}>
              <PaymentCard
                selected={values.options_prepaid === 1}
                onClick={() => handleSelectPayment(1)}
                price={withoutDomainPriceMonthly}
                paymentType={'wh/create.string3'}
              />
              <PaymentCard
                selected={values.options_prepaid === 12}
                onClick={() => handleSelectPayment(12)}
                showTag={t('wh/create.step5_string8')}
                price={withoutDomainPriceYearly}
                paymentType={'wh/create.string4'}
              />
              <PaymentCard
                selected={values.options_prepaid === 120}
                onClick={() => handleSelectPayment(120)}
                showTag={t('wh/create.step5_string9')}
                price={withoutDomainPriceMonthly * 96}
                paymentType={'wh/create.string5'}
              />
            </Grid>
          </Grid>
          {values.domain_checked != domainTabs.transfer_an_existing_domain &&
            values.domain_checked != domainTabs.no_need_for_a_domain && (
              <Grid container>
                <Grid xs={7} sm={4} md={3} lg={3} xl={2}>
                  <Styles.HeadingStep5>{t('wh/create.step5_string3')}</Styles.HeadingStep5>
                </Grid>
                <Grid container xs={5} sm={8} md={9} lg={9} xl={10}>
                  <Styles.ParaStep5>
                    {t('wh/create.step5_string10', { price: priceCalculator(values.prices.domain) })}
                  </Styles.ParaStep5>
                </Grid>
              </Grid>
            )}
          <Grid container>
            <Grid xs={7} sm={4} md={3} lg={3} xl={2}>
              <Styles.HeadingStep5>{t('wh/create.step5_string4')}</Styles.HeadingStep5>
            </Grid>
            <Grid container xs={5} sm={8} md={9} lg={9} xl={10}>
              <Styles.ParaStep5>
                {t('wh/create.step5_string11', {
                  currency_symbol: userAccount.account_currency_symbol,
                  price: priceCalculator(
                    values.options_prepaid == 1
                      ? monthlyPrice
                      : values.options_prepaid == 12
                      ? yearlyPrice
                      : monthlyPrice * 96,
                    false,
                  ),
                })}
              </Styles.ParaStep5>
            </Grid>
          </Grid>
          <Styles.PaymentMethodButton>
            {buttons.map((data) => (
              <Styles.PaymentMethodSingleButton
                greyOut={data.id == 3 && !isSafari}
                selected={data.id == selected}
                key={data.id}
                onClick={() => {
                  data.id != 3 ? handleClick(data.id) : data.id == 3 && isSafari ? handleClick(data.id) : null;
                }}
              >
                <P>{t(`public/checkout.${data.text}`)}</P>
              </Styles.PaymentMethodSingleButton>
            ))}
          </Styles.PaymentMethodButton>
          {selected != 100 && <P>{t(`public/checkout.${buttons[selected]?.heading}`)}</P>}
        </Styles.MarginContainer>
      </Heading>
    </Styles.WHStep3SC>
  );
};
export default WHStep5;
